import { Component } from '@angular/core';
import { Router } from '@angular/router';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Message} from "primeng/primeng";
import {AuthenticationService} from "./Login/authentication.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  msgs: Message[] = [];
  formLogin : FormGroup;
  loading = false;
  error = '';
  online = false;
  offline = true;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private fb:FormBuilder) { }

  ngOnInit() {
    // reset login status
    this.crearControlesLogin();
    this.authenticationService.logout();
  }

  crearControlesLogin(){
    this.formLogin = this.fb.group({
      email : ['',Validators.required],
      password : ['',Validators.required],
    });
  }
  mensajes(severity,summary,detail){
    this.msgs = [];
    this.msgs.push({severity:severity, summary:summary, detail:detail});
  }
  login() {
    this.loading = true;
    this.authenticationService.login(this.formLogin.value['email'],this.formLogin.value['password'])
      .subscribe(
        rt => {
          this.offline = false;
          this.online = true;
          this.loading = false;
          this.router.navigate(['/tienda']);
        },
        er => { this.mensajes('error','Acceso denegado','Verifique su Usuario y Contraseña');
          this.loading = false;
        },
        () =>  {

        });
  }
}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/app.component.ts